import type { SVGProps } from 'react';
const SvgActivity = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.5 3H10a2.5 2.5 0 0 0-2 1 2.5 2.5 0 0 0-2-1H1.5a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5H6a1.5 1.5 0 0 1 1.5 1.5.5.5 0 0 0 1 0A1.5 1.5 0 0 1 10 13h4.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5ZM6 12H2V4h4a1.5 1.5 0 0 1 1.5 1.5v7A2.488 2.488 0 0 0 6 12Zm8 0h-4c-.541 0-1.068.175-1.5.5v-7A1.5 1.5 0 0 1 10 4h4v8Z"
    />
  </svg>
);
export default SvgActivity;
